/* Inline product grids for blog posts
   Usage in blog HTML:
   <div data-inline-products data-products="handle1, handle2, handle3, handle4"></div>
   - Adds to REAL Shopify cart via /cart/add.js
   - Hard-limits to 4 products
   - Uses your card grid classes so styling matches
*/

(function () {
  const SELECTOR = '[data-inline-products]';
  const MAX_ITEMS = 4;

  function moneyEUR(cents) {
    // Keep display consistent; your store may auto-format on PDP
    return (cents / 100).toFixed(2) + ' €';
  }

  function buildCard(p) {
    // choose the first available variant (fallback: first)
    const v = (p.variants || []).find(x => x.available) || p.variants[0];
    const img = (p.images && p.images[0]) ? p.images[0] : null;
    const base = v ? v.price : 0;

    const card = document.createElement('div');
    card.className = 'card product-card product-card--card product-card--thickness flex flex-col leading-none relative';

    card.innerHTML = `
      <div class="product-card__media relative h-auto">
        <a class="block relative media media--square media--contain overflow-hidden" href="${p.url}" aria-label="${p.title}">
          ${img ? `<img src="${img}" alt="${p.title.replace(/"/g,'&quot;')}" loading="lazy">` : ''}
        </a>
      </div>

      <div class="product-card__content grow flex flex-col justify-start text-center">
        <div class="product-card__details flex flex-col lg:flex-row items-baseline w-full">
          <p class="grow">
            <a class="product-card__title reversed-link text-base-xl font-medium leading-tight" href="${p.url}">${p.title}</a>
          </p>
        </div>
      </div>

      <div class="product-card__content">
        ${
          v && v.available ? `
          <form class="product-form" data-inline-add>
            <input type="hidden" name="id" value="${v.id}">
            <input type="hidden" name="quantity" value="1" class="inline-qty">

            <div class="variant-buttons grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-2 mb-3">
              ${[1,5,10,30].map(q => `
                <button type="button" class="variant-button border px-3 py-1 text-sm rounded w-full" data-qty="${q}">
                  <span class="block text-lg font-semibold leading-tight text-center">
                    ${q}<br><span class="text-sm font-semibold">pack</span>
                  </span>
                </button>
              `).join('')}
            </div>

            <div class="flex justify-between text-sm mb-4">
              <div class="variant-total font-semibold" data-price-display>${moneyEUR(base)}</div>
              <div class="variant-per-can text-gray-500" data-price-per-can>${moneyEUR(base)} /can</div>
            </div>

            <button type="submit" class="button button--primary product-form__submit w-full">
              <span class="btn-text">Add to cart</span>
            </button>
          </form>` : `
          <div class="quick-add flex justify-center w-full">
            <button type="button" class="button button--secondary button--blur" disabled>Sold Out</button>
          </div>`
        }
      </div>
    `;

    // Wire up behavior only if the form exists (i.e., product available)
    const form = card.querySelector('[data-inline-add]');
    if (form) {
      const qtyInput = form.querySelector('.inline-qty');
      const priceDisplay = form.querySelector('[data-price-display]');
      const perCanDisplay = form.querySelector('[data-price-per-can]');
      const btns = card.querySelectorAll('.variant-button');

      const baseNum = base;

      const selectBtn = (b) => {
        btns.forEach(x => x.classList.remove('selected','ring-2','ring-black'));
        b.classList.add('selected','ring-2','ring-black');
        const q = parseInt(b.dataset.qty, 10);
        qtyInput.value = q;
        priceDisplay.textContent = moneyEUR(baseNum * q);
        perCanDisplay.textContent = moneyEUR(baseNum) + ' /can';
      };

      if (btns.length) selectBtn(btns[0]);
      btns.forEach(b => b.addEventListener('click', () => selectBtn(b)));

      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const fd = new FormData(form);
        try {
          await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
          // If your theme uses a specific event/hook to open the cart drawer, trigger it here:
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } catch (err) {
          console.error('Add to cart failed', err);
        }
      });
    }

    return card;
  }

  async function fetchProduct(handle) {
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) return null;
      return await res.json();
    } catch (e) {
      return null;
    }
  }

  async function hydrateBlock(el) {
    // Accept either data-products="a,b,c,d" or a nested <script type="application/json"> with handles
    let handles = (el.dataset.products || '')
      .split(',')
      .map(s => s.trim())
      .filter(Boolean);

    // Hard limit to 4 even if they pasted more
    handles = handles.slice(0, MAX_ITEMS);
    if (!handles.length) return; // nothing to do

    const products = await Promise.all(handles.map(fetchProduct));
    const items = products.filter(Boolean);
    if (!items.length) return;

    const grid = document.createElement('div');
    grid.className = 'product-grid card-grid card-grid--4 mobile:card-grid--2 grid';

    items.forEach(p => grid.appendChild(buildCard(p)));
    el.replaceWith(grid);
  }

  function init() {
    const blocks = document.querySelectorAll(SELECTOR);
    if (!blocks.length) return;

    // Lazy hydrate when visible
    const io = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries, obs) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              obs.unobserve(entry.target);
              hydrateBlock(entry.target);
            }
          });
        }, { rootMargin: '200px 0px' })
      : null;

    blocks.forEach(el => {
      if (io) io.observe(el);
      else hydrateBlock(el);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
})();
